import React from "react"
import { Redirect } from "react-router-dom"
import { useAuth } from "../../context/AuthContext"
import "../dashboard/dashboard.css"

export default function AdminPrivateRoute({ children }) {
  const { user, loading } = useAuth()

  if (loading) {
    return <div className='dashboard-auth-loading'>Loading...</div>
  }

  if (!user) {
    return <Redirect to='/signin' />
  }

  if (user.role !== "admin") {
    return <Redirect to='/dashboard' />
  }

  return <>{children}</>
}
